import React, {useEffect, useState} from 'react';

import { navigate } from "gatsby"
import useMapContextState from "../context/mapContext";

import { GoogleMap, Marker, LoadScript, Polygon, useGoogleMap } from '@react-google-maps/api';

const mapStyles = [
  {elementType: 'geometry', stylers: [{color: '#242f3e'}]},
  {elementType: 'labels.text.stroke', stylers: [{color: '#242f3e'}]},
  {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text.fill',
    stylers: [{color: '#d59563'}]
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [{color: '#d59563'}]
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{color: '#263c3f'}]
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [{color: '#6b9a76'}]
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{color: '#38414e'}]
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [{color: '#212a37'}]
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [{color: '#9ca5b3'}]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{color: '#746855'}]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{color: '#1f2835'}]
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [{color: '#f3d19c'}]
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [{color: '#2f3948'}]
  },
  {
    featureType: 'transit.station',
    elementType: 'labels.text.fill',
    stylers: [{color: '#d59563'}]
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{color: '#17263c'}]
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{color: '#515c6d'}]
  },
  {
    featureType: 'water',
    elementType: 'labels.text.stroke',
    stylers: [{color: '#17263c'}]
  }
];

const lineOptions = {
  fillColor: "lightblue",
  fillOpacity: 1,
  strokeColor: "red",
  strokeOpacity: 1,
  strokeWeight: 2,
  clickable: false,
  draggable: false,
  editable: false,
  geodesic: false,
  zIndex: 1
}

const bonn = {
  lat: 50.73438,
  lng: 7.09549
}

const BigMap = ({posts}) => {

  const { focus } = useMapContextState();
  const [ map, setMap ] = useState(null);

  useEffect(() => {
    if (map) {
      if(focus) {
        map.panTo(focus);
        map.setZoom(14);
      } else {
        fitBounds(map)
      }
    }
  }, [focus, map])


  const locations = posts.map(post => ({
    slug: post.node.fields.slug,
    caption: post.node.frontmatter.location,
    lng: parseFloat(post.node.frontmatter.longitude),
    lat: parseFloat(post.node.frontmatter.latitude)
  })) || [];

  const lngs = locations.map(loc => loc.lng);
  const lats = locations.map(loc => loc.lat);

  const fitBounds = (map) => {

    if(!focus) {
      const bounds = new window.google.maps.LatLngBounds();

      locations.map(loc => {
        bounds.extend({lat: loc.lat, lng: loc.lng});
      });
      map.fitBounds(bounds);
    }
  }

  console.log({focus});
  console.log({center: focus ? focus : bonn});

  return (
      <GoogleMap
        id={`bigMap`}
        mapContainerStyle={{
          height: "100%",
          minWidth: "50vw",
          width: "100%"
        }}
        zoom={12}
        center={bonn}
        onLoad={map => { setMap(map); fitBounds(map);}}
        options={{styles: mapStyles}}
      >
        {locations.map((loc, index) => {
          const prevLoc = locations[index - 1];

          return (
            <>
              {index !== 0 && <Polygon paths={[prevLoc, loc]} options={lineOptions}></Polygon>}
              <Marker
                onClick={(e) => {
                  navigate(loc.slug);
                }}
                key={index} position={loc} title={loc.caption}
              />
            </>
          )
        })}
      </GoogleMap>
  )
}


export default BigMap;